import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle, ArrowLeft } from 'lucide-react';

export default function PaymentCancel() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center bg-[#f6f9fc] px-5 py-20">
      <div className="bg-white rounded-2xl shadow-lg max-w-md w-full p-10 text-center">
        <XCircle size={56} className="text-gray-400 mx-auto mb-6" />
        <h1 className="font-heading font-extrabold text-2xl text-[#132b4d] mb-2">Checkout cancelled</h1>
        <p className="text-gray-600 mb-7">No payment was taken. You can return to the report library whenever you’re ready.</p>
        <Link to="/reports" className="inline-flex items-center gap-2 bg-[#1ca5dc] text-white font-heading font-semibold px-8 py-3.5 rounded-full hover:bg-[#132b4d] transition-colors">
          <ArrowLeft size={18} /> Back to reports
        </Link>
      </div>
    </div>
  );
}
